export const FeedbackTagPattern = {
  Link: /(\[link\])(.+?)(\[\/link\])/g,
  Org: /\[org\]/g,
};
